export default {
      id: "notifications__parameter_control-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__parameter_control",
      toString: function () {
        return this.url;
      }
    }